
// EmployeeDetails.jsx
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Typography } from "@mui/material";
import { Button, Col, Container, Row } from "react-bootstrap";
import Spinner from "../components/Spinner";
import Employee from "./Employee";
import EmployeeAvatar from "./EmployeeAvatar";
import EmployeeStatusBadge from "./EmployeeStatusBadge";
import EmployeePinValidation from "./EmployeePinValidation";
import EmployeeTimeEntry from "./EmployeeTimeEntry";
import { login, logout} from "../features/auth/authSlice";
import {getUserTimeEntries, updateTimeEntry, createTimeEntry} from "../features/timeentries/timeentrySlice.jsx";
import { timeentryreset, getTimeEntries } from "../features/timeentries/timeentrySlice.jsx";
import { getEmployees } from "../features/employees/employeeSlice";



const EmployeeDetails = ({ employee, selectedEmployee, handleClick, handleEmployeeClick }) => {
  const { user, isSuccessAuth } = useSelector((state) => state.auth);
  const entries = useSelector(state => state.entries.entries);
  const { 
    UpdateEntryisSuccess, 
    UpdateEntryisLoading, 
    CreateEntryisSuccess, 
    CreateEntryisLoading } = useSelector((state) => state.entries);
    let [newstatus, setNewstatus ] = useState(null);
   
    const dispatch = useDispatch();

    const handleSetStatus = (color) => {
      setNewstatus(color);
    };

  
  // it worked even with this commented but keep just in case
    //   useEffect(() => {
  //     // console.log('newstatus is from Details: '+ newstatus);
  // },[UpdateEntryisSuccess,CreateEntryisSuccess]);


  useEffect(() => {
    if (isSuccessAuth && user) {
      dispatch(getUserTimeEntries(user));
    }
    return () => {
      dispatch(timeentryreset());
    };
  }, [dispatch, isSuccessAuth, user]);




  return (
    <Container>
      <Row className="mg-top text-center"><Typography gutterBottom={true} variant="h4">{selectedEmployee.username}</Typography></Row>
        <div style={{ position: "relative" }}>
          <Row className="px-0 px-lg-5 d-flex h-100 align-items-center justify-content-center">
            <EmployeeAvatar 
              employee={selectedEmployee}
              isSuccessAuth={isSuccessAuth}
            />
            <EmployeeStatusBadge 
              employee={selectedEmployee} 
              status={newstatus}
            />
          </Row>
        </div>

      { !isSuccessAuth && 
        <div>
          <EmployeePinValidation 
            email={selectedEmployee.email} 
          />
        </div>
      }

      { isSuccessAuth && 
        <div>
          <EmployeeTimeEntry 
            entries ={entries}
            employee ={selectedEmployee}
            handleSetStatus={handleSetStatus}
            newstatus={newstatus}
          />
        </div>
      }

      <Row className="mg-top">
        <Col md={12} className="text-center">
          <Button variant="primary" onClick={handleClick}>Go Back</Button>
        </Col>
      </Row>
    </Container>
  );
};

export default EmployeeDetails;

